import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('FilterSelectionAttributes')
class FilterSelectionAttributes {
  @JsonProperty('contentType', String, true)
  // @ts-expect-error TS2322 - strict migration
  contentType: string = undefined;
  @JsonProperty('workflowState', String, true)
  // @ts-expect-error TS2322 - strict migration
  workflowState: string = undefined;
  @JsonProperty('workflowTag', String, true)
  // @ts-expect-error TS2322 - strict migration
  workflowTag: string = undefined;
}

export default FilterSelectionAttributes;
